<template>
<div>
  <div class="m_context">
<el-row :gutter="20" style="margin-bottom: 20px;">
<el-col :span="3" style="padding-left: 24px;">
<el-button type="primary" @click="add" style="width:100%" >{{$t('lin_btn.lockOta')}}</el-button>
	         </el-col>
	        </el-row>
	<el-table
	  	:data="arrdata"
	  	border
	  	style="width:100%"
	  	ref="arrdata">
	  		<el-table-column
	  		prop="otaName"
	  		:label="$t('lin_global.name')"
	  		width="220">
	  		</el-table-column>
	  		<el-table-column
	  		prop="otaVersion"
        :label="$t('lin_global.version')"
	  		width="150">
	  		</el-table-column>
	  		<el-table-column
	  		prop="mechanismName"
        :label="$t('lin_global.label_areaid')"
	  		width="250">
	  		</el-table-column>
	  		<el-table-column
	  		prop="terminalNums"
        :label="$t('terminal.OtaList.lock_num')"
	  		width="200">
	  		</el-table-column>

	  		<el-table-column
          :label="$t('lin_global.ope')">
				<template slot-scope="scope">
					<!-- <el-button @click.stop="lockRow(scope.row.lockId)" type="text">{{$t('lin_btn.unlock')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.unlock')" placement="top">
					<el-button type='text' @click.stop="lockRow(scope.row.lockId)"><i class="fa fa-unlock" style=""></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
  </div>
</div>
</template>

<script>
	import axios from 'axios'
    import { baseurl } from '../../api/url'
	export default{
		name:'info',
		data(){
			return{
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				arrdata:[]
			}
		},
		created(){
			this.getData(1)
		},
		methods:{
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage)
		    },

			add:function(){
				this.$router.push({ path: '/terOta/lock' })
			},

			lockRow:function(userid){
				var params = {ids:userid};
				this.$confirm(this.$t('terminal.OtaList.lock_tips'),this.$t('lin_btn.tips'),{
					confirmButtonText: this.$t('lin_btn.confirm'),
          			cancelButtonText:  this.$t('lin_btn.cancel'),
          			type: 'warning'
				}).then(()=>{
					axios.post(`${baseurl}/ota_lock/unlock.do`,params).then(res=>{
						if (res.data.status == 200) {
					      this.getData(1)
			              this.$message.success(this.$t('lin_global.unlock_success'));
			            } else {
          this.$message.error(res.data.message)
			              //console.log(res.data.message)
			            }
					})
				}).catch(() => {

        		})

			},
			getData:function(page){
				this.currentPage = page;
				var mechanismId = localStorage.getItem('mechanismId');
				var params = {"page":page,"rows":this.pageSize,"mechanismId":mechanismId}
				axios.post(`${baseurl}/ota_lock/list.do`,params).then(res=>{
					//console.log("查看取到的列表")
					//console.log(res.data)
		            this.arrdata = res.data.data;
		            this.totalRecords = res.data.total;
		        })
			}
		}
	}
</script>



// WEBPACK FOOTER //
// OtaList.vue?b3e6ecba